import axios from "./axios-decorator";

const baseAxiosUrl = window.location.origin;

/**
* Get app config.
*/
export const getAppConfig = async (): Promise<any> => {
    let url = `${baseAxiosUrl}/api/serventias/getappconfig`;
    return await axios.get(url);
}

/**
* Get serventias by ID.
*/
export const getMeetingData = async (ancora: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/serventias/getmeeting?ancora=${ancora}`;
    return await axios.get(url, undefined, false);
}

/**
* Get serventias collection from the api.
*/
export const getMeetingsData = async (
    filter?: string,
    secaoJudiciaria?: string,
    filterView?: any,
    userPinned?: string,
): Promise<any> => {
    let meetingRequest = {
        filter: filter,
        secaoJudiciaria: secaoJudiciaria,
        userPinned: userPinned,
        filterView: filterView,
    }

    let url = `${baseAxiosUrl}/api/serventias/getall?meeting=${JSON.stringify(meetingRequest)}`;
    return await axios.get(url, undefined, false);
}

/**
* Get serventias paged collection from the api.
*/
export const getMeetingsDataPaged = async (
    offset: number,
    limit: number,
    filter?: string,
    sortProperty?: string,
    sortType?: string,
    secaoJudiciaria?: string,
    userPinned?: string,
    filterView?: any,
): Promise<any> => {
    let meetingPagedRequest = {
        offset: offset,
        limit: limit,
        filter: filter,
        orderProperty: sortProperty,
        orderType: sortType,
        secaoJudiciaria: secaoJudiciaria,
        userPinned: userPinned,
        filterView: filterView,
    }

    let url = `${baseAxiosUrl}/api/serventias/getmeetingspaged?meetingPaged=${JSON.stringify(meetingPagedRequest)}`;
    return await axios.get(url, undefined, false);
}

/**
* Get visão geral atendimentos data.
*/
export const getGeneralViewData = async (count: number, ancora?: string): Promise<any> => {
    let params = count == 0 ? `` : `?daysCount=${count}`;

    if (ancora && count != 0) {
        params = params + `&ancora=${ancora}`;
    } else if (ancora && count == 0) {
        params = `?ancora=${ancora}`;
    }

    let url = `${baseAxiosUrl}/api/serventias/getgeneralviewdata${params}`;
    return await axios.get(url);
}

/**
* Get visão geral atendimentos data - Painel de Atendimento.
*/
export const getGeneralViewUnidadeData = async (ancora: string, count: number): Promise<any> => {
    let url = `${baseAxiosUrl}/api/serventias/getgeneralviewunidadedata?ancora=${ancora}&daysCount=${count}`;
    return await axios.get(url);
}

/**
* Get total metrics data.
*/
export const getMetricsData = async (ancora?: string): Promise<any> => {
    ancora = ancora ? `?ancora=${ancora}` : ``;
    let url = `${baseAxiosUrl}/api/serventias/gettotalmetricsdata${ancora}`;
    return await axios.get(url);
}

/**
* Get active unidades data.
*/
export const getActiveUnidadesData = async (count: number): Promise<any> => {
    let url = `${baseAxiosUrl}/api/serventias/getactiveunidadesdata?daysCount=${count}`;
    return await axios.get(url);
}

/**
* Get relatorio de atendimentos data.
*/
export const getAttendancesReportData = async (count?: number, ancora?: string): Promise<any> => {
    ancora = ancora ? `&ancora=${ancora}` : ``;
    let url = `${baseAxiosUrl}/api/serventias/getattendancesreportdata?daysCount=${count}${ancora}`;
    return await axios.get(url);
}

/**
* Get filtered metrics item data.
*/
export const getFilteredMetricsItemData = async (ancora?: string, count?: number): Promise<any> => {
    let url = `${baseAxiosUrl}/api/serventias/getfiltereditemmetricsdata?count=${count}&ancora=${ancora}`;
    return await axios.get(url);
}

/**
* Get the total amount of requests over 7 days;
*/
export const getLastRequestsLast7Days = async (): Promise<any> => {
    let url = `${baseAxiosUrl}/api/serventias/getrequestslast7days`;
    return await axios.get(url);
}

/**
* Get the total amount of requests over 7 days;
*/
export const getIndexedMeetings = async (): Promise<any> => {
    let url = `${baseAxiosUrl}/api/serventias/getindexedmeetings`;
    return await axios.get(url);
}

/**
* Get the total amount of active meetings over 7 days;
*/
export const getMeetingsLast7Days = async (): Promise<any> => {
    let url = `${baseAxiosUrl}/api/serventias/getmeetingslast7days`;
    return await axios.get(url);
}

/**
* Create Serventia.
*/
export const createOrUpdateServentia = async (payload: any): Promise<any> => {
    let url = `${baseAxiosUrl}/api/serventias/createorupdateserventia`;
    return await axios.put(url, payload);
}

/**
* Terminate queue call (atendimento).
*/
export const endCall = async (id: string, justification: string): Promise<any> => {
    const payload = {
        notes: justification,
    }

    const url = `${baseAxiosUrl}/api/serventias/endcall?id=${id}`;
    return await axios.put(url, payload);
}

/**
* Cancel queue call (atendimento).
*/
export const cancelCall = async (id: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/serventias/cancelcall?id=${id}`;
    return await axios.put(url, null);
}

/**
* Get queue by id.
*/
export const getQueueById = async (id: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/serventias/getqueuebyid?id=${id}`;
    return await axios.get(url);
}

/**
* Get queue by meeting id - Used for meeting extensibility.
*/
export const getQueueDataByMeetingId = async (meetingId: string): Promise<any> => {
    let url = baseAxiosUrl + `/api/serventias/getqueuebymeetingid?meetingId=${meetingId}`;
    return await axios.get(url);
}

/**
* Get queues status count
*/
export const getQueuesStatusCount = async (
    ancora: string,
    date?: Date | null,
    atendenteId?: string | null,
    filter?: string | null,
    internalAccessEnabled?: boolean): Promise<any> => {

    let dateTime = date ? `&date=${date}` : ``;
    let atendente = atendenteId ? `&atendenteId=${atendenteId}` : ``;
    let filters = filter ? `&filter=${filter}` : ``;
    let internal = internalAccessEnabled ? `&internalChannelEnabled=${internalAccessEnabled}` : ``;

    let url = `${baseAxiosUrl}/api/serventias/getqueuesstatuscount?ancora=${ancora}${dateTime}${atendente}${filters}${internal}`;
    return await axios.get(url);
}

/**
* Get all meeting queues by id.
*/
export const getAllQueuesData = async (
    ancora: string,
    offset: number,
    limit: number,
    date?: Date | null,
    atendenteId?: string | null,
    filter?: string | null,
    internalAccessEnabled?: boolean): Promise<any> => {

    let dateTime = date ? `&date=${date}` : ``;
    let atendente = atendenteId ? `&atendenteId=${atendenteId}` : ``;
    let filters = filter ? `&filter=${filter}` : ``;
    let internal = internalAccessEnabled ? `&internalChannelEnabled=${internalAccessEnabled}` : ``;

    let url = `${baseAxiosUrl}/api/serventias/getallqueues?ancora=${ancora}&offset=${offset}&limit=${limit}${dateTime}${atendente}${filters}${internal}`;
    return await axios.get(url, undefined, false);
}

/**
* Get started queues.
*/
export const getStartedQueues = async (
    ancora: string,
    offset: number,
    limit: number,
    date?: Date | null,
    atendenteId?: string | null,
    filter?: string | null,
    internalAccessEnabled?: boolean): Promise<any> => {

    let dateTime = date ? `&date=${date}` : ``;
    let atendente = atendenteId ? `&atendenteId=${atendenteId}` : ``;
    let filters = filter ? `&filter=${filter}` : ``;
    let internal = internalAccessEnabled ? `&internalChannelEnabled=${internalAccessEnabled}` : ``;

    let url = `${baseAxiosUrl}/api/serventias/getstartedqueues?ancora=${ancora}&offset=${offset}&limit=${limit}${dateTime}${atendente}${filters}${internal}`;
    return await axios.get(url);
}

/**
* Get ended queues.
*/
export const getEndedQueues = async (ancora: string, offset: number, limit: number, date?: Date | null, atendenteId?: string | null, filter?: string | null): Promise<any> => {
    let dateTime = date ? `&date=${date}` : ``;
    let atendente = atendenteId ? `&atendenteId=${atendenteId}` : ``;
    let filters = filter ? `&filter=${filter}` : ``;

    let url = `${baseAxiosUrl}/api/serventias/getendedqueues?ancora=${ancora}&offset=${offset}&limit=${limit}${dateTime}${atendente}${filters}`;
    return await axios.get(url);
}

/**
* Get expired queues.
*/
export const getExpiredQueues = async (ancora: string, offset: number, limit: number, date?: Date | null, filter?: string | null): Promise<any> => {
    let dateTime = date ? `&date=${date}` : ``;
    let filters = filter ? `&filter=${filter}` : ``;

    let url = `${baseAxiosUrl}/api/serventias/getexpiredqueues?ancora=${ancora}&offset=${offset}&limit=${limit}${dateTime}${filters}`;
    return await axios.get(url);
}

/**
* Get queues history
*/
export const getQueuesHistory = async (queueId: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/serventias/getqueuehistory?queueId=${queueId}`;
    return await axios.get(url);
}

/**
* Delete Serventia by Id.
*/
export const deleteServentia = async (serventiaId: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/serventias/deleteserventiabyid/?serventiaId=${serventiaId}`;
    return await axios.put(url);
}

// Create online meeting and update status
export const createOnlineMeetingAndUpdateStatus = async (queueId: string, ancora: string, appId?: string): Promise<any> => {
    let url = baseAxiosUrl + `/api/serventias/createonlinemeetingandupdatestatus?meetingQueueId=${queueId}&ancora=${ancora}&appManifestId=${appId}`;
    return await axios.get(url);
}

// Get user permissions
export const getUserPermissions = async (): Promise<any> => {
    let url = baseAxiosUrl + `/api/serventias/getuserrole`;
    return await axios.get(url);
}

/**
* Get Admin UPN.
*/
export const isAdmin = async (): Promise<any> => {
    let url = `${baseAxiosUrl}/api/serventias/isadmin`;
    return await axios.getAdmin(url);
}

/** 
* Get app setup config.
*/
export const getAppSetup = async (): Promise<any> => {
    let url = baseAxiosUrl + `/api/serventias/getappsetup`;
    return await axios.get(url);
}

/**
* Get PowerBI report url.
*/
export const getReportUrl = async (): Promise<any> => {
    let url = baseAxiosUrl + `/api/serventias/getreporturl`;
    return await axios.get(url);
}

/**
* Get locale.
*/
export const getLocaleData = async (): Promise<any> => {
    let url = baseAxiosUrl + `/api/serventias/getlocale`;
    return await axios.get(url);
}

/**
* Get current user photo - Used for meeting extensibility.
*/
export const getCurrentUserPhoto = async (userId: string): Promise<any> => {
    let url = baseAxiosUrl + `/api/serventias/getcurrentuserphoto?userId=${userId}`;
    return await axios.get(url);
}

/**
* Get selected permission group from list.
*/
export const getGroups = async (ancora: string): Promise<any> => {
    let url = baseAxiosUrl + `/api/serventias/getgroupdata?ancora=${ancora}`;
    return await axios.get(url);
}

/**
* Create scheduled queue.
*/
export const createScheduledQueue = async (payload: any): Promise<any> => {
    let url = baseAxiosUrl + `/api/serventias/createscheduledqueue`;
    return await axios.post(url, payload);
}

/**
* Update scheduled queue.
*/
export const updateScheduledQueue = async (payload: any): Promise<any> => {
    let url = baseAxiosUrl + `/api/serventias/updatescheduledqueue`;
    return await axios.post(url, payload);
}

/**
* Get atendentes filter.
*/
export const getAtendentesFilter = async (ancora: string, date: Date): Promise<any> => {
    let url = baseAxiosUrl + `/api/serventias/getatendentesfilter?ancora=${ancora}&date=${date.toISOString()}`;
    return await axios.get(url);
}

/**
* Get members of group.
*/
export const getMembersOfGroup = async (groupId: string): Promise<any> => {
    let url = baseAxiosUrl + `/api/serventias/getmembersofgroupdata?groupId=${groupId}`;
    return await axios.get(url);
}

/**
* Get drive item from meeting recordings.
*/
export const getQueueRecordingFile = async (fileId: string, queueId: string): Promise<any> => {
    let url = baseAxiosUrl + `/api/serventias/getqueuerecordingfile?fileId=${fileId}&queueId=${queueId}`;
    return await axios.get(url);
}

/**
* Sent proactively bot message to meeting chat.
*/
export const sendMeetingNotification = async (meetingNotificationData: any): Promise<any> => {
    let url = baseAxiosUrl + `/api/serventias/sendmeetingnotification?meetingNotificationData=${JSON.stringify(meetingNotificationData)}`;
    return await axios.post(url);
}

/**
* Get queue attachments.
*/
export const getQueueAttachments = async (queueId: string): Promise<any> => {
    let url = baseAxiosUrl + `/api/serventias/getqueueattachments?meetingQueueId=${queueId}`;
    return await axios.get(url);
}

/**
* Update assunto and notes for meeting extensibility.
*/
export const updateAssuntoAndNotes = async (id: string, data: any): Promise<any> => {
    let url = `${baseAxiosUrl}/api/serventias/updateassuntoandnotes?id=${id}`;
    return await axios.put(url, data);
}

/**
* Validates shared mailbox.
*/
export const validatesSharedMailbox = async (sharedMailboxMail: string): Promise<any> => {
    let url = baseAxiosUrl + `/api/serventias/validatessharedmailbox?sharedMailboxEmail=${sharedMailboxMail}`;
    return await axios.get(url);
}